import { useCallback, useMemo, useState } from "react";
import { updateOrgStatus } from "./updateOrgStatusSlice";
import { useDispatch,useSelector } from "react-redux";
import useNotification from "../../../../../components/notification/useNotification";
import { isSuccessResponse } from "../../../../../common/utils";
import { selector as updateOrgStatusApi } from './updateOrgStatusSlice';
import { useSpinner } from "../../../../../customHooks";
interface IProps {
  orgAdminName: string;
  orgName: string;
  isEnabled: boolean;
}

interface IUpdateOrgStatusPayload {
  displayName: string;
  isEnabled: boolean;
}
const useEnableDisablePopup = (props: IProps) => {
  const [show, setShow] = useState(false);
  const { orgAdminName, isEnabled, orgName } = props;
  const dispatch: any = useDispatch();
  const updateOrgStatusResponse = useSelector(updateOrgStatusApi);
  useSpinner(updateOrgStatusResponse.status);

  const handleClose = useCallback(() => {
    setShow(false);
  }, []);

  const handleShow = useCallback(() => {
    setShow(true);
  }, []);

  const popupFunctionality: string = useMemo(
    () => (isEnabled ? "Disable" : "Enable"),
    [isEnabled]
  );
  const popupTitle: string = useMemo(
    () => `${popupFunctionality} Org Admin`,
    [popupFunctionality]
  );

  const popupContent: string = useMemo(() => {
    const action: string = popupFunctionality.toLowerCase();
    const accountAdmin: string = orgAdminName ? orgAdminName + "'s" : "this";
    return `Are you sure you want to ${action} ${accountAdmin} account?`;
  }, [popupFunctionality, orgAdminName]);

  const { showSuccessNotification, showWarningNotification } =
    useNotification();

  const handleOrgStatusChange = () => {
    const OrgStatusChangePayload: IUpdateOrgStatusPayload = {
      displayName: orgName,
      isEnabled: isEnabled,
    };
    dispatch(updateOrgStatus(OrgStatusChangePayload)).then((response) => {
      if (isSuccessResponse(response.payload)) {
        showSuccessNotification(response.payload.message);
      } else {
        showWarningNotification(response.payload.response.data.message);
      }
    });
    setShow(false);
  };

  return {
    show,
    handleClose,
    handleShow,
    popupFunctionality,
    popupTitle,
    popupContent,
    handleOrgStatusChange,
  };
};

export default useEnableDisablePopup;
